export const APP_VERSION = '1.3.1';
export const IOS_APP_STORE_URL = 'https://apps.apple.com/eg/app/id6751147108';
export const ANDROID_APK_URL = 'https://www.dropbox.com/scl/fi/6zhhstg76153hll1nx3ol/myGUNI-1.3.1.apk?rlkey=cvr4ilez63kd7dkhctzdassxc&st=0kehbnu4&dl=1';

// API Configuration
//export const API_BASE_URL = 'http://192.168.1.2:4001'; // testing route
export const API_BASE_URL = 'https://android-logger.vercel.app'; // Points to Website Backend
export const WEBSITE_URL = 'https://myguni.vercel.app'; // Website domain for sharing

// Theme configuration matching the app's exact dark theme
export const theme = {
  colors: {
    // Primary colors from the app
    primary: '#EAB308',           // GUC Yellow from app
    primaryDark: '#EAB308',       // Keep same yellow for consistency
    secondary: '#10B981',         // Success green from app

    // Background colors matching the app exactly
    background: '#2C2C2C',        // App's dark background
    surface: '#3A3A3A',          // App's surface color
    surfaceVariant: '#4A4A4A',    // App's surfaceSecondary

    // Text colors from app
    onBackground: '#FFFFFF',      // App's text color
    onSurface: '#FFFFFF',         // App's text color
    onSurfaceVariant: '#B0B0B0',  // App's textSecondary color

    // Border and accent colors from app
    border: '#555555',            // App's border color
    accent: '#EAB308',            // App's primary yellow

    // Gradients using app colors
    gradient: 'linear-gradient(135deg, #EAB308 0%, #10B981 100%)',
    cardGradient: 'linear-gradient(135deg, rgba(234, 179, 8, 0.05) 0%, rgba(16, 185, 129, 0.05) 100%)'
  },

  spacing: {
    xs: '0.5rem',
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem',
    xl: '3rem',
    xxl: '4rem'
  },

  borderRadius: {
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px'
  },

  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
      '5xl': '3rem'
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    }
  },

  shadows: {
    sm: '0 2px 8px rgba(0, 0, 0, 0.12)',
    md: '0 4px 16px rgba(0, 0, 0, 0.16)',
    lg: '0 8px 32px rgba(0, 0, 0, 0.24)'
  }
};